import { Result, Tree } from 'types'

import _TREE from './tree.json'

export { EXCHANGE_META } from './exchanges'

export const TREE = _TREE as Tree

/// src: https://docs.google.com/spreadsheets/d/1NJtgv2G9ZCyQi6s8H8OZR0eXU5PPjiP06h7zjnVzNKY
export const RESULTS: { [key: string]: Result } = {
  fire: {
    name: '火',
    title: '#いろいろやろうぜ ＃短期投資',
    desc:
      '失敗をしたくない完璧主義者タイプ。物事を能動的に進められる力はあるが判断に迷う場合がある。投資タイプが「火の精霊」の人は利益を一番大切にする。大きな森を見るより、木を見てしまう。仮想通貨投資においては分散投資を心掛け、取引を頻繁にし利益が出たらすぐ売買する投資に向いている。メジャーな仮想通貨がオススメで、売買手数料が無料・マイナス手数料の取引所がオススメ！',
    shareText:
      '【投資タイプ診断】私の投資タイプは「火の精霊」\n「火の精霊」の人は失敗をしたくない完璧主義者タイプ！あなたの「投資精霊」何？',
    exchanges: [
      {
        code: 'GMOC',
        desc:
          'メジャーな仮想通貨5種類が揃っている！しかも取引手数料・出金手数料が無料。本格的に仮想通貨投資を始めたい方はまず、GMOコインの口座を開設し海外取引所の利用もあり！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['取引手数料', 'Maker：-0.01%、Taker：0.05%'],
          ['レバレッジ', 'O'],
        ],
      },
      {
        code: 'BTBK',
        desc:
          '人気仮想通貨リップル（XRP）、モナコイン（MONA）を取り扱っている。マイナス手数料であるため頻繁に取引を行う人にオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、MONA'],
          ['取引手数料', 'Maker：-0.02% Taker：0.12%'],
          ['レバレッジ', 'X'],
        ],
      },
      {
        code: 'QUON',
        desc:
          '日本のスタートアップ企業では、"メリカリ"に次く2社目の「ユニコーン企業」とにかく運営資金が豊富で安心感がある！Liquidが発行したQASH購入予定の人にはオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、XRP、QASH'],
          ['取引手数料', 'BTC/JPY、QASHペアー：無料。その他：0.1％'],
          ['レバレッジ', 'X'],
        ],
      },
    ],
  },
  flower: {
    name: 'お花',
    title: '#バッチリがんばれ #楽観的 #中短期投資',
    desc:
      '投資はタイミングと思っており、判断力が優れているタイプ。状況によっては短期投資も行う場合もある。投資タイプが「お花の精霊」の人は投資した商品に花が咲いたとき（利益が見込めるとき）に売買することが得意。一方で、周りの意見に流されないように注意も必要だ。仮想通貨投資においては中短期の投資に向いており、板取引ができる取引所がオススメ！',
    shareText:
      '【投資タイプ診断】私の投資タイプは「お花の精霊」\n「お花の精霊」の人は投資はタイミングと思っており、判断力が優れているタイプ！あなたの「投資精霊」何？',
    exchanges: [
      {
        code: 'GMOC',
        desc:
          'メジャーな仮想通貨5種類が揃っている！しかも取引手数料・出金手数料が無料。本格的に仮想通貨投資を始めたい方はまず、GMOコインの口座を開設し海外取引所の利用もあり！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['取引手数料', 'Maker：-0.01%、Taker：0.05%'],
          ['レバレッジ', 'O'],
        ],
      },
      {
        code: 'BTBK',
        desc:
          '人気仮想通貨リップル（XRP）、モナコイン（MONA）を取り扱っている。マイナス手数料であるため頻繁に取引を行う人にオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、MONA'],
          ['取引手数料', 'Maker：-0.02% Taker：0.12%'],
          ['レバレッジ', 'X'],
        ],
      },
      {
        code: 'QUON',
        desc:
          '日本のスタートアップ企業では、"メリカリ"に次く2社目の「ユニコーン企業」とにかく運営資金が豊富で安心感がある！Liquidが発行したQASH購入予定の人にはオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、XRP、QASH'],
          ['取引手数料', 'BTC/JPY、QASHペアー：無料, その他：0.1％'],
          ['レバレッジ', 'O'],
        ],
      },
    ],
  },
  grass: {
    name: '草',
    title: '#MPつかうな　#戦略家  #ファンダメンタル',
    desc:
      '物事の本質を見極める目が効くタイプ。ファンダメンタル的な要素をとても大事にし、プロジェクトの成長をじっくりと待つ。投資タイプが「草の精霊」の人は周りの考えと自分の考えを整理し、判断することが得意。国内で取引の経験を積み、多くの仮想通貨が上場されている海外の取引所利用もあり！',
    shareText:
      '【投資タイプ診断】私の投資タイプは「草の精霊」\n「草の精霊」の人は物事の本質を見極める目が効くタイプ！あなたの「投資精霊」何？',
    exchanges: [
      {
        code: 'DMMB',
        desc:
          '板取引はできないが、取引方法がシンプルで分かりやすい。手数料が安く取り扱い通貨が豊富',
        details: [
          ['取り扱い通貨数', '７種類'],
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、XEM、ETC'],
          ['手数料', '★★★★'],
        ],
      },
      {
        code: 'CCJP',
        desc:
          '取引手数料は無料だが、実際には「スプレッド」で高くとられる。取り扱い通貨数は日本一BTCだけ板取引可',
        details: [
          ['取り扱い通貨数', '11種類'],
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、XEM、ETC、MONA、LSK、FCT、XLM'],
          ['手数料', '★★'],
        ],
      },
      {
        code: 'BTBK',
        desc:
          '板取引可能で手数料は安いが初心者には操作が難しいかもしれない。日本の人気通貨MONAを取引したいならbitbank一押し！',
        details: [
          ['取り扱い通貨数', '6種類'],
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、MONA'],
          ['手数料', '★★★★'],
        ],
      },
    ],
  },
  stone: {
    name: '石',
    title: '＃いのちをだいじに #頑固 #安定 ＃コツコツ',
    desc:
      '周りの意見よりは自分の考えを大切にするタイプ。仲のいい友達にオススメされる投資商品があってもなかなかぶれない強い信念を持っており、成功するための努力を惜しまない。投資タイプが「石の精霊」の人は投資で損失がでると受ける精神的ショックが大きい。仮想通貨投資においてはBTCを含め、メジャーな仮想通貨でポートフォリオを構成し、積立投資（国内唯一Coincheckで可能）や貸出で着実に資産を増やす方法がオススメ！',
    shareText:
      '【投資タイプ診断】私の投資タイプは「石の精霊」\n「石の精霊」の人は周りの意見よりは自分の考えを大切にするタイプ！あなたの「投資精霊」何？',
    exchanges: [
      {
        code: 'CCJP',
        desc:
          '取り扱い通貨数が日本一で今後も増える予定。積立投資、貸出サービスも気軽に利用できる。初心者でも操作しやすいUIでCoincheckから仮想通貨を入門する人も少ない!',
        details: [
          [
            '取り扱い通貨',
            'BTC、ETH、BCH、LTC、XRP、XEM、ETC、MONA、LSK、FCT、XLM',
          ],
          ['貸出対象通貨', 'BTC、ETH、BCH、LTC、XRP、XEM、ETC、MONA、LSK、FCT'],
          ['貸出利率', '1~5%'],
          ['最小申込数量', '10万円相当の仮想通貨'],
        ],
      },
      {
        code: 'BTBK',
        desc:
          '人気仮想通貨リップル（XRP）、モナコイン（MONA）を取り扱っている。手数料が安いため、頻繁に取引を行う人にオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、MONA'],
          ['貸出対象通貨', 'BTC'],
          ['貸出利率', '3~5%'],
          ['最小申込数量', '1BTC'],
        ],
      },
      {
        code: 'GMOC',
        desc:
          'メジャーな仮想通貨5種類が揃っている！取引手数料が安く、出金手数料が無料。本格的に仮想通貨投資を始めたい方はまず、GMOコインの口座を開設し海外取引所の利用もあり！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['貸出対象通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['貸出利率', '5%'],
          ['最小申込数量', '・10BTC・100ETH・50BCH・300LTC・10万XRP'],
        ],
      },
    ],
  },
  thunder: {
    name: '雷',
    title: '＃ガンガンいこうぜ　#柔軟性 ＃短期投資',
    desc:
      '自由な性格の持ち主で臨機応変な対応が得意なタイプ。独自の投資ルールをもっており、失敗をおそれない。投資タイプが「雷の精霊」の人は失敗からも学ぶ場合も多く、短期勝負に向いている。変動する数字にも強く、結果は常に変わるという柔軟性も持っており、損失が発生しても大きく動揺しない。仮想通貨投資においては、アルトコインの売買やレバレッジ取引ができる取引所がオススメ！',
    shareText:
      '【投資タイプ診断】私の投資タイプは「雷の精霊」\n「雷の精霊」の人は自由な性格の持ち主で臨機応変な対応が得意なタイプ！あなたの「投資精霊」何？',
    exchanges: [
      {
        code: 'DMMB',
        desc:
          'レバレッジ取り扱い通貨数が日本一！様々な経験が必要な初心者にオススメ！販売所方式の取引所で初心者が操作しやすい。',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP、XEM、ETC'],
          ['板取引', 'X'],
          ['取引手数料', '★★★★'],
        ],
      },
      {
        code: 'GMOC',
        desc:
          'メジャーな仮想通貨5種類が揃っている！スプレッドは国内最低！手数料をとにかく抑えたい人にはオススメ！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['板取引', 'O'],
          ['取引手数料', '★★★★★'],
        ],
      },
      {
        code: 'DCRT',
        desc:
          'KDDIなどの大手企業が出資しており、安心感抜群！スプレッドも狭く、アプリも使いやすい！',
        details: [
          ['取り扱い通貨', 'BTC、ETH、BCH、LTC、XRP'],
          ['板取引', 'X'],
          ['取引手数料', '★★★★'],
        ],
      },
    ],
  },
}

export const EXCHAGES_INTRO_URL =
  'https://www.coinjinja.com/blog/posts/2019/8/exchangeranking'
